import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loadStatus: false,
  loadArchive: false,
  status: [],
  chart: [],
  archive: [],
  manager: [],
  coutnRip: 0,
  countSwen: 0,
};

const statusSlice = createSlice({
  name: "status",
  initialState,
  reducers: {
    getAllNewStatus(state, action) {
      state.loadStatus = false;
      state.status = action.payload;
      state.manager = action.payload;
      state.loadStatus = true;
    },
    getStatus(state, action) {
      state.loadStatus = false;
      state.chart = action.payload;
      state.loadStatus = true;
    },
    getAllArchiveStatus(state, action) {
      state.loadArchive = false;
      state.archive = action.payload;
      state.loadArchive = true;
    },
    loadStatus(state, action) {
      state.loadStatus = action.payload;
    },
    loadArchive(state, action) {
      state.loadArchive = action.payload;
    },
    updateStatusItem(state, action) {
      const updated = action.payload;
      console.log("🔴 Redux updateStatusItem received:", updated);
      const idx = state.manager.findIndex((s) => s._id === updated._id);
      console.log("🔴 Found index in manager:", idx);
      if (idx !== -1) {
        state.manager[idx] = updated;
        console.log("🔴 Updated manager[", idx, "]:", state.manager[idx]);
      } else {
        console.warn("🔴 Status not found in manager array");
      }
    },
  },
});

export default statusSlice.reducer;
export const {
  getAllNewStatus,
  getStatus,
  getAllArchiveStatus,
  loadStatus,
  loadArchive,
  updateStatusItem,
} = statusSlice.actions;
